import React, { useState } from "react";
import ActionMenuListItem from "canvas-core-react/lib/ActionMenuListItem";
import ActionMenuList from "canvas-core-react/lib/ActionMenuList";
import IconShow from "canvas-core-react/lib/IconShow";
import SimpleBar from "simplebar-react";
import SecondaryButton from "canvas-core-react/lib/SecondaryButton";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import AdminTable from "../../shared/table";
import Modal from "../../utils/customModal";
import { getAllLogs } from "../../../Redux/actions/logsAction";
import { getSessionInfo } from "../../../Redux/reducer/session";
import { getLogs, getCountLogs } from "../../../Redux/reducer/logs";
import { getFilters, loadingModal } from "../../utils/functions";
import useApi from "../../hooks/useApi";
import PropTypes from "prop-types";

const LogComponent = (props) => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();

  const [page, setPage] = useState(0);
  const [modal, setModal] = useState(false);
  const [menus, setMenus] = useState({});
  const [spinnerModal, setSpinnerModal] = useState(false);
  const [modalContent, setModalContent] = useState([]);

  const { getApiCAll } = useApi();

  const elements = useSelector((state) => getCountLogs(state));
  const loggedUser = useSelector((state) => getSessionInfo(state));
  const logs = useSelector((state) => getLogs(state));

  const getTableColumns = () => {
    return [
      { selector: "company", name: `${t("logs.detail.table.company")}` },
      { selector: "cif", name: `${t("logs.detail.table.cif")}` },
      { selector: "date", name: `${t("logs.detail.table.date")}` },
      {
        selector: "transaction",
        name: `${t("logs.detail.table.transaction")}`,
      },
      { selector: "state", name: `${t("logs.detail.table.state")}` },
      {
        selector: "action",
        name: `${t("logs.detail.table.action")}`,
        center: true,
        cellFormatter: menuItems,
      },
    ];
  };

  const menuItems = (row) => {
    const iconShow = () => {
      return <IconShow className="TextButton__icon--left" />;
    };

    const handleMenu = (id, open) => {
      const tmpMenus = { ...menus };
      tmpMenus[`menu-${id}`] = open;
      setMenus(tmpMenus);
    };

    return (
      <ActionMenuList
        dialogPosition="bottom-right"
        iconType="horizontal-small"
        bottomSheet={{
          heading: "Actions",
          secondaryAction: {
            onClick: () => {},
            label: "Cancel",
          },
        }}
        isMenuOpen={menus[`menu-${row.obj.id}`] || false}
        setIsMenuOpen={(open) => handleMenu(row.obj.id, open)}
      >
        <ActionMenuListItem icon={iconShow} onClick={() => openModal(row.obj)}>
          {t("general.labels.detail")}
        </ActionMenuListItem>
      </ActionMenuList>
    );
  };

  const getData = () => {
    let result = [];

    if (logs && logs.length > 0) {
      logs.map((item) => {
        result.push({
          company: item.companyName,
          cif: item.cif,
          date: new Date(item.createDate).toLocaleDateString("es-ES"),
          transaction: item.action,
          state: getState(item.severity),
          obj: item,
        });
      });
    }

    return result;
  };

  const getState = (severity) => {
    switch (severity) {
      case "SUCCESS":
        return (
          <span className="satisfactory">{t("logs.detail.satisfactory")}</span>
        );
      case "ERROR":
        return (
          <span className="unsatisfactory">
            {t("logs.detail.unsatisfactory")}
          </span>
        );
    }
  };

  const handleTableChange = ({ page, sizePerPage }) => {
    setPage(page);

    return dispatch(
      getAllLogs(page, sizePerPage, loggedUser.userType, props.filters),
    );
  };

  const openModal = (item) => {
    let content = (
      <div className="log-detail">
        <div className="row">
          <div className="input col-lg-4">
            <label htmlFor="country">{t("logs.detail.modal.country")}</label>
            <input type="text" name="country" value={item.country} readOnly />
          </div>
          <div className="input col-lg-3">
            <label htmlFor="cif">{t("logs.detail.modal.cif")}</label>
            <input type="text" name="cif" value={item.cif} readOnly />
          </div>
          <div className="input col-lg-5">
            <label htmlFor="companyName">
              {t("logs.detail.modal.company")}
            </label>
            <input
              type="text"
              name="companyName"
              value={item.companyName}
              readOnly
            />
          </div>
        </div>
        <div className="row">
          <div className="input col-lg-6">
            <label htmlFor="createBy">{t("logs.detail.modal.createBy")}</label>
            <input type="text" name="createBy" value={item.createBy} readOnly />
          </div>

          <div className="input col-lg-2">
            <label htmlFor="createBy">{t("logs.detail.modal.hour")}</label>
            <input
              type="text"
              name="createBy"
              value={`${new Date(item.createDate).getHours()}:${new Date(
                item.createDate,
              )
                .getMinutes()
                .toString()
                .padStart(2, "0")}`}
              readOnly
            />
          </div>
        </div>

        <div className="row">
          <div className="input col-lg-6">
            <label htmlFor="updateBy">{t("logs.detail.modal.updateBy")}</label>
            <input type="text" name="updateBy" value={item.updateBy} readOnly />
          </div>

          <div className="input col-lg-2">
            <label htmlFor="updateDate">{t("logs.detail.modal.hour")}</label>
            <input
              type="text"
              name="updateDate"
              value={`${new Date(item.updateDate).getHours()}:${new Date(
                item.createDate,
              )
                .getMinutes()
                .toString()
                .padStart(2, "0")}`}
              readOnly
            />
          </div>
        </div>

        <div className="row">
          <div className="input col-lg-12">
            <label htmlFor="createBy">{t("general.labels.detail")}</label>
            <p>{item.message}</p>
          </div>
        </div>
      </div>
    );

    setMenus({});
    setModalContent(content);
    setModal(true);
  };

  const closeModal = () => {
    setModalContent([]);
    setModal(false);
  };

  const getActions = () => {
    return (
      <div className="form-actions clearfix">
        <SecondaryButton id="go-back" onClick={props.loadFilters}>
          {t("general.buttons.back")}
        </SecondaryButton>
        {/* <button id="go-back" className="button button--pill" onClick={() => props.loadFilters()}>{t('general.buttons.back')}</button> */}
      </div>
    );
  };

  const onExport = async (fileExtension) => {
    setSpinnerModal(true);
    let query = getFilters(props.filters);
    const path = `/audit-logs/downloadFile/user/${loggedUser.userType}/type/${fileExtension}/landscape/true/language/${i18n.language}?search=${query}`;
    try {
      const {
        data: { data },
      } = await getApiCAll(path);
      setSpinnerModal(false);
      downloadFile(data);
    } catch (error) {
      setSpinnerModal(false);
      console.error(error);
    }
  };

  const downloadFile = (data) => {
    let link = document.createElement("a");
    link.setAttribute("id", "download-anchor");
    link.href = `data:${data.mime_type};base64,77u/${data.file_base64}`;
    link.download = `${data.filename}`;
    link.click();
    link.remove();
  };

  return (
    <div id="admin-logs">
      <div className="audit-logs-export-container">
        <p>Descargar</p>
        <div className="audit-logs-export-btn audit-logs-export-btn-green">
          <button
            id="excel-btn"
            className="btn-green"
            type="button"
            onClick={() => onExport("CSV")}
          >
            Excel
          </button>
        </div>
        <div className="audit-logs-export-btn audit-logs-export-btn-red">
          <button
            id="pdf-btn"
            className="btn-red"
            type="button"
            onClick={() => onExport("PDF")}
          >
            PDF
          </button>
        </div>
      </div>
      <AdminTable
        headers={getTableColumns()}
        data={getData()}
        page={page}
        totalSize={elements}
        sizePerPage={10}
        onTableChange={handleTableChange}
        actions={getActions()}
      />

      <Modal key={`table-modal`} show={modal} handleClose={() => closeModal()}>
        <div className="modal-detail-content log-container">
          <SimpleBar forceVisible="y" style={{ maxHeight: 300 }}>
            {modalContent}
          </SimpleBar>
          <div className="actions logs-actions">
            <SecondaryButton className="continue-btn" onClick={closeModal}>
              {t("general.buttons.close")}
            </SecondaryButton>
            {/* <a onClick={() => closeModal()} className="continue-btn">{t('general.buttons.close')}</a> */}
          </div>
        </div>
      </Modal>
      {spinnerModal && loadingModal()}
    </div>
  );
};

LogComponent.propTypes = {
  loadFilters: PropTypes.func,
  filters: PropTypes.array,
};

export default LogComponent;
